import { Menu } from 'components/ui'
import { useApp } from 'context/app-context'
import useApi from 'hooks/use-api'
import { AssetRef } from 'lib/assets/asset'
import { FC } from 'react'

interface Props {
  typeLabel: string
  asset: AssetRef
  onSuccess?: () => void
}

const DuplicateAssetMenuItem: FC<Props> = ({ typeLabel, asset, onSuccess }) => {
  const { setFlashNotice } = useApp()
  const api = useApi()

  const handleDuplicate = async () => {
    try {
      await api(`/api/assets/${asset.type}/${asset.uuid}/duplicate`, 'POST')

      if (typeof onSuccess === 'function') {
        onSuccess()
      }

      setFlashNotice({
        type: 'success',
        message: typeLabel + ' successfully duplicated!',
      })
    } catch (error) {
      setFlashNotice({
        type: 'danger',
        message: `Unable to duplicate ${typeLabel}\n${error}`,
      })
    }
  }

  return <Menu.Item label="Duplicate" onClick={handleDuplicate} />
}

export default DuplicateAssetMenuItem
